import { render, staticRenderFns } from "./ClienteWishList.vue?vue&type=template&id=4c893f44&scoped=true"
import script from "./ClienteWishList.vue?vue&type=script&lang=js"
export * from "./ClienteWishList.vue?vue&type=script&lang=js"
import style0 from "./ClienteWishList.vue?vue&type=style&index=0&id=4c893f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c893f44",
  null
  
)

export default component.exports